/**
 * row.jsx
 *
 * @Author: jruif
 * @Date: 2017/7/5 下午4:38
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import extend from 'object-assign';
import { isObject } from '../util/isType';

const propTypes = {
    /** 水平对齐，`left`以及`right` 将被移除 */
    justify: PropTypes.oneOf(['start', 'end', 'center', 'between', 'around', 'left', 'right']),
    /** 垂直对齐 */
    align: PropTypes.oneOf(['top', 'bottom', 'middle', 'stretch']),
    /** 栅格间隔 */
    gutter: PropTypes.oneOfType([PropTypes.number, PropTypes.string]), // 栅格间隔 20
    /** @ignore */
    number: PropTypes.oneOfType([PropTypes.number, PropTypes.string]), // 个数 24
    /** @ignore */
    prefixCls: PropTypes.string,
    /** 是否不设置最大宽 */
    expanded: PropTypes.bool,
    /** 是否折叠（Row的marginLeft、marginRight和Col的paddingLeft、paddingRight叠加） */
    collapse: PropTypes.bool,
};

const defaultProps = {
    prefixCls: 'row',
    gutter: 20,
    number: 24,
    expanded: false,
    collapse: false,
};

/**
 * Row
 * */
export default function Row(props) {
    const { prefixCls, children, expanded, collapse, justify, align, className, gutter, style } = props;
    const classes = classNames(
        prefixCls,
        {
            [`${prefixCls}-justify-${justify === 'left' ? 'start' : justify === 'right' ? 'end' : justify}`]: justify,
            [`${prefixCls}-align-${align}`]: align,
            expanded,
            collapse,
        },
        className,
    );

    const preGutter = Number(gutter) / 2;

    return (
        <div
            className={classes}
            style={extend(
                preGutter !== 10 // 20使用默认样式处理
                    ? {
                          marginLeft: -preGutter,
                          marginRight: -preGutter,
                      }
                    : {},
                style,
            )}>
            {React.Children.map(children, child => {
                const childType = child
                    ? isObject(child.type) || typeof child.type === 'function'
                        ? child.type.displayName || child.type.name
                        : child.type
                    : child;
                if (childType === 'NeatUI.Col' && preGutter !== 10) {
                    return React.cloneElement(child, {
                        colStyle: {
                            paddingLeft: preGutter,
                            paddingRight: preGutter,
                        },
                    });
                }
                return child;
            })}
        </div>
    );
}

Row.propTypes = propTypes;
Row.defaultProps = defaultProps;
Row.displayName = 'NeatUI.Row';



// WEBPACK FOOTER //
// ./src/grid/Row.jsx